var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Notifications component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNotifications extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9949 1.10498C7.75236 1.10498 4.31312 4.54423 4.31312 8.78675V15.9616L4.31273 15.9636C4.30642 15.9966 4.29464 16.0502 4.27451 16.1182C4.23383 16.2558 4.16187 16.4428 4.03938 16.6351C3.80776 16.9988 3.37327 17.4234 2.4879 17.5449C2.09718 17.5986 1.81474 17.9456 1.84161 18.3391C1.86848 18.7325 2.19549 19.038 2.58987 19.038H21.2677C21.317 19.0396 21.3645 19.0393 21.4098 19.037C21.816 19.0163 22.1316 18.6755 22.1213 18.2688C22.1109 17.8622 21.7783 17.538 21.3715 17.538H21.2956C21.1548 17.5272 20.7785 17.4412 20.4131 17.1623C20.0496 16.8848 19.712 16.4272 19.6767 15.6563V8.78676C19.6767 4.54424 16.2374 1.10498 11.9949 1.10498ZM5.06312 16.0201C5.80849 16.1033 5.80844 16.1037 5.80839 16.1041L5.06312 16.0201ZM5.80839 16.1041L5.81312 16.0618V8.78675C5.81312 5.37265 8.58079 2.60498 11.9949 2.60498C15.409 2.60498 18.1767 5.37266 18.1767 8.78676V15.6879L18.1773 15.7032C18.2078 16.4513 18.4254 17.0583 18.7403 17.538H5.24039C5.26258 17.5056 5.28396 17.4733 5.30455 17.4409C5.51855 17.1049 5.64217 16.7829 5.71294 16.5436C5.74854 16.4232 5.77145 16.3214 5.78591 16.246C5.79315 16.2083 5.79831 16.1769 5.8019 16.1529C5.80369 16.1408 5.8051 16.1306 5.80617 16.1223L5.80755 16.1113L5.80807 16.1069L5.80839 16.1041ZM10.4392 21.395C10.025 21.395 9.68921 21.7308 9.68921 22.145C9.68921 22.5592 10.025 22.895 10.4392 22.895H13.5603C13.9745 22.895 14.3103 22.5592 14.3103 22.145C14.3103 21.7308 13.9745 21.395 13.5603 21.395H10.4392Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNotifications.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNotifications.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNotifications.prototype, "size", void 0);
if (customElements.get('cat-icon-notifications') === undefined) {
    customElements.define('cat-icon-notifications', BlocksIconNotifications);
}
